import { Title } from "ui/Typography"
import { ChatHistory } from "pagesV2/pro/Messages/ChatHistory"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createConversation, getConversations, cleanConversations } from "store/conversations"
import { Card } from "antd"
import styles from "./index.module.css"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

const MessagesTab = ({ active }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [subscription, setSubscription] = useState(null)
  const [selectedConversationId, setSelectedConversationId] = useState(null)
  const client = useSelector((state) => state?.clients?.client)

  useEffect(() => {
    if (active) {
      setSelectedConversationId(null)
      dispatch(cleanConversations())
      const conversation_id = client?.conversation_id
      if (conversation_id) {
        dispatch(getConversations()).then(() => {
          setSelectedConversationId(conversation_id)
        })
      } else {
        dispatch(createConversation({ participant_id: client?.user_id })).then((conversation) => {
          setSelectedConversationId(conversation?.id)
          dispatch(getConversations())
        })
      }
    }
  }, [dispatch, active, client])

  return (
    <Card>
      <Title level={5}>{t("client.messages")}</Title>
      <ChatHistory
        moduleName={styles.clientMessageTab}
        selectedConversationId={selectedConversationId}
        subscription={subscription}
        setSubscription={setSubscription}
        guideClientId={client?.id}
        isShowHeader={false}
      />
    </Card>
  )
}

MessagesTab.propTypes = {
  active: PropTypes.bool
}

export default MessagesTab
